import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskReveal = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterLabel = ({ number, label, dark = false }) => (
  <div
    data-testid={`chapter-label-${label.toLowerCase().replace(/\s+/g, "-")}`}
    className={`flex items-baseline gap-4 text-xs font-semibold uppercase tracking-[0.22em] ${
      dark ? "text-[#C9A66B]" : "text-[#C9A66B]"
    }`}
  >
    <span className="font-display text-sm italic font-light">{number}</span>
    <span className={`h-px w-10 ${dark ? "bg-[#C9A66B]/50" : "bg-[#C9A66B]/60"}`} aria-hidden="true" />
    <span>{label}</span>
  </div>
);
